import React from "react"
import PropTypes from "prop-types"
import { semantic } from '@lexody/design-tokens'


class NewCityPrompt extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showAlert: ''
    }
  }

  componentWillMount() {
    let city = this.props.user.location.split(/,/)[0]
    let stateName = this.props.user.location.split(/,/)[1]
    if(stateName === ' CA' || stateName === ' MA') {
      this.setState({
        city: city,
        stateName: stateName,
        showAlert: true
      })
    } else {
      this.setState({
        city: city,
        stateName: stateName,
        showAlert: false
      })
    }
  }



  render() {
    if(this.state.showAlert === true) {
        return(
          <div style={{height: '100%', width: '100%', position: 'absolute', backgroundColor: semantic.primary.text.label, borderRadius: 3, textAlign: 'center'}}>
            <h4 style={{fontWeight: '600', marginTop: 48, marginBottom: 48, fontSize: 20}}>Lexody launches into<br />{this.state.city} Jan 1, 2019</h4>

            <h4 style={{fontSize: 20}}>If you set up your profile<br />before January 1, you get<br /><span style={{color: semantic.premium.surface.default, fontWeight: '600'}}>free Pro access</span><br />for a year!</h4>
            <div className="btn_primary" style={{padding: 15, marginTop: 80}} onClick={() => this.setState({showAlert: false})}>Set up Profile</div>
          </div>
        )
    } else {
      return null
    }
  }
}

export default NewCityPrompt;
